import { Routes } from '@angular/router';
import { HomePageComponent } from './features/public/pages/home-page/home-page.component';
import { AboutComponent } from './features/public/pages/about/about.component';
import { ContactUsComponent } from './features/public/pages/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './features/public/pages/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './features/public/pages/terms-and-conditions/terms-conditions.component';
import { TermsUseComponent } from './features/public/pages/terms-of-use/terms-use.component';
import { FaqsComponent } from './features/public/pages/faqs/faqs.component';
import { FeedbackComponent } from './features/public/pages/feedback/feedback.component';
import { ManageAccountComponent } from './features/manage-account/pages/manage-account/manage-account.component';
import { businessAreaGuard } from './core/guards/business-role.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomePageComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'faqs', component: FaqsComponent },
  {
    path: 'feedback',
    component: FeedbackComponent,
  },
  { path: 'terms-conditions', component: TermsConditionsComponent },
  { path: 'privacy', component: PrivacyPolicyComponent },
  { path: 'terms-of-use', component: TermsUseComponent },
  {
    path: 'flight',
    loadChildren: () =>
      import('./features/flights/flight-routing.module').then(
        (m) => m.flightRoutes
      ),
  },
  {
    path: 'order',
    loadChildren: () =>
      import('./features/order/order-routing.module').then(
        (m) => m.ORDER_ROUTES
      ),
  },
  {
    path: 'business',
    canMatch: [businessAreaGuard],
    loadChildren: () =>
      import('./features/business/business.routes').then(
        (m) => m.BUSINESS_ROUTES
      ),
  },
  {
    path: 'manage-account',
    loadChildren: () =>
      import('./features/manage-account/manage-account.routing.module').then(
        (m) => m.ManageAccount
      ),
  },
];
